import * as React from 'react';
import cx from 'classnames';

import { Drawer, Form, Input, Button } from 'antd';

import styles from './EditAppDrawer.scss';

export interface ICreateAppParams {
  name: string;
  icon?: string;
}
interface IProps {
  open: boolean;
  onRequstClose(): void;

  isSubmitting: boolean;
  onSubmit(application: ICreateAppParams): void;

  className?: string;
}

interface IEditAppFormProps {
  onSubmit(application: ICreateAppParams): void;
  isSubmitting: boolean;
}
const EditAppForm: React.FunctionComponent<React.PropsWithChildren<IEditAppFormProps>> = React.memo((props) => {
  const [form] = Form.useForm();
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  const onFinish = (values) => {
    console.log('Success:', values);

    props.onSubmit(values);
  };
  const onFinishFailed = ({ errorFields }) => {
    form.scrollToField(errorFields[0].name);
  };

  return (
    <Form form={form} onFinish={onFinish} onFinishFailed={onFinishFailed} className={styles.form} {...formItemLayout}>
      <Form.Item label="Name" name="name" rules={[{ required: true, message: `Please enter the Application's name!` }]}>
        <Input placeholder="Application name" />
      </Form.Item>
      <Form.Item label="Icon" name="icon">
        <Input placeholder="Application icon" />
      </Form.Item>
      <Button type="primary" htmlType="submit" loading={props.isSubmitting} className={styles.submitButton}>
        Submit
      </Button>
    </Form>
  );
});

/**
 * @type {React.FunctionComponent}
 */
export const EditAppDrawer: React.FunctionComponent<React.PropsWithChildren<IProps>> = React.memo((props) => {
  return (
    <Drawer
      title="Create Application"
      visible={props.open}
      width={600}
      onClose={props.onRequstClose}
      className={cx(styles.EditAppDrawer, props.className)}
    >
      <EditAppForm onSubmit={props.onSubmit} isSubmitting={props.isSubmitting} />
    </Drawer>
  );
});

EditAppDrawer.defaultProps = {
  className: null,
};
